export const ADD_ORDER = 'orders/addOrder'
export const SET_ORDERS = 'orders/setOrders'
export const OPEN_ORDER = 'orders/openOrder'
export const UPDATE_ORDER = 'orders/updateOrder'
export const CANCEL_ORDER = 'orders/cancelOrder'

export const SET_ORDERS_PENDENTS = 'orders/setOrdersPendents'
